import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import './noteIcon.scss';

class NoteIcon extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    text: PropTypes.string,
    showIcon: PropTypes.bool,
  };

  static defaultProps = {
    text: null,
    showIcon: true,
  };

  state = {
    isShow: false,
  };

  onMouseEnter = () => this.setState(state => (state.isShow ? null : { isShow: true }));

  onMouseLeave = () => this.setState(state => (!state.isShow ? null : { isShow: false }));

  render() {
    const { children, showIcon, text } = this.props;
    const { isShow } = this.state;

    return (
      <div
        className={cn('noteIcon', { noteIconWithoutImage: !showIcon })}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        {text && <span>{text}</span>}
        <div className={cn('noteIcon-content', { 'noteIcon-content--visibled': isShow })}>{children}</div>
      </div>
    );
  }
}

export default NoteIcon;
